export const GOOGLE_MAPS_KEY = 'AIzaSyD3bNz4yLXmbao2Uq5rNRSwPdFW-gTLkMw';
